import { GooglePlaceDetailsResponse } from '../../static/models/GooglePlaceDetailsResponse';
import { SearchLocation } from '../../static/models/SearchLocation';

export function convertPlaceDetailsToUserLocation(placeDetails: GooglePlaceDetailsResponse): SearchLocation {
    if (placeDetails.results.length === 0) {
        return <SearchLocation>{};
    }

    const street = placeDetails.results[0].address_components.find(x => x.types.includes('street_number'));
    const route = placeDetails.results[0].address_components.find(x => x.types.includes('route'));
    const city = placeDetails.results[0].address_components.find(x => x.types.includes('locality'));
    const state = placeDetails.results[0].address_components.find(x => x.types.includes('administrative_area_level_1'));
    const zip = placeDetails.results[0].address_components.find(x => x.types.includes('postal_code'));
    const county = placeDetails.results[0].address_components.find(x =>
        x.types.includes('administrative_area_level_2'),
    );

    const pickupLocation: SearchLocation = {
        street: `${street?.long_name || ''} ${route?.long_name || ''}`.trim(),
        city: city?.long_name || '',
        county: county?.long_name || '',
        state: state?.short_name || '',
        zip: zip?.long_name || '',
        latitude: placeDetails.results[0].geometry.location.lat,
        longitude: placeDetails.results[0].geometry.location.lng,
    };

    return pickupLocation;
}

export function calculateHaversineDistance(
    lat1: number,
    lon1: number,
    lat2: number | undefined,
    lon2: number | undefined,
): number {
    if (!lat2 || !lon2) {
        return 0;
    }
    // Earth's radius varies from 6356.752 km at the poles to 6378.137 km at the equator
    const radius = 6371.0;
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.asin(Math.sqrt(a));

    const kmToMiles = 0.621371;
    const distance = radius * c * kmToMiles;

    return Math.round((distance + Number.EPSILON) * 100) / 100;
}

function toRadians(degree: number): number {
    const PI = 3.1415926;
    return (degree * PI) / 180;
}
